(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
  class PncBannerSlider {
    constructor(el) {
      this.el = el;
      this.trackWrapper = el.querySelector('.pnc-slider__track-wrapper');
      this.track = el.querySelector('.pnc-slider__track');
      this.slides = Array.from(el.querySelectorAll('.pnc-slide'));
      this.dots = Array.from(el.querySelectorAll('.pnc-slider__dot'));
      this.prevBtn = el.querySelector('.pnc-slider__arrow--prev');
      this.nextBtn = el.querySelector('.pnc-slider__arrow--next');
      this.progressBar = el.querySelector('.pnc-slider__progress-bar');

      this.current = 0;
      this.total = this.slides.length;
      this.autoplay = el.dataset.autoplay === 'true';
      this.speed = parseInt(el.dataset.speed, 10) || 5000;
      this.timer = null;
      this.isHovered = false;
      this.isDragging = false;
      this.isPointerDown = false;
      this.startX = 0;
      this.startY = 0;
      this.currentX = 0;
      this.startTime = 0;
      this.preventClick = false;

      if (this.total > 1) {
        this.init();
      }
    }

    init() {
      this.updateTrackPosition(false);
      this.updateSlides();

      // Navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.prev();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.next();
        });
      }

      // Pagination dots
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          this.goTo(i);
        });
      });

      // Pointer drag & touch swipe
      if (this.trackWrapper) {
        this.trackWrapper.addEventListener('dragstart', (e) => e.preventDefault());

        this.trackWrapper.addEventListener('pointerdown', (e) => this.onPointerDown(e));
        this.trackWrapper.addEventListener('pointermove', (e) => this.onPointerMove(e));
        this.trackWrapper.addEventListener('pointerup', (e) => this.onPointerUp(e));
        this.trackWrapper.addEventListener('pointercancel', (e) => this.onPointerUp(e));

        // Prevent accidental link navigation while dragging
        this.trackWrapper.addEventListener('click', (e) => {
          if (this.preventClick) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);

        // Keyboard arrow navigation
        this.trackWrapper.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.prev();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.next();
          }
        });
      }

      // Pause on hover
      this.el.addEventListener('mouseenter', () => {
        this.isHovered = true;
        this.pause();
      });
      this.el.addEventListener('mouseleave', () => {
        this.isHovered = false;
        if (this.autoplay && !this.isDragging) this.play();
      });

      // Pause when tab hidden
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pause();
        } else if (this.autoplay && !this.isHovered && !this.isDragging) {
          this.play();
        }
      });

      // Pause when out of view
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (this.autoplay && !this.isHovered && !this.isDragging) this.play();
            } else {
              this.pause();
            }
          });
        }, { threshold: 0.2 });
        observer.observe(this.el);
      }

      // Start autoplay
      if (this.autoplay) {
        this.play();
      }
    }

    onPointerDown(e) {
      if (e.button !== undefined && e.button !== 0) return; // Only main button
      if (e.target.closest('.pnc-slider__arrow') || e.target.closest('.pnc-slider__dots')) return;

      this.isPointerDown = true;
      this.isDragging = false;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.currentX = e.clientX;
      this.startTime = Date.now();

      this.pause();

      if (this.trackWrapper && typeof this.trackWrapper.setPointerCapture === 'function') {
        try {
          this.trackWrapper.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
    }

    onPointerMove(e) {
      if (!this.isPointerDown) return;

      this.currentX = e.clientX;
      const deltaX = this.currentX - this.startX;
      const deltaY = e.clientY - this.startY;

      if (!this.isDragging) {
        // Vertical scroll detection
        if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 8) {
          this.isPointerDown = false;
          if (this.trackWrapper && typeof this.trackWrapper.releasePointerCapture === 'function') {
            try {
              this.trackWrapper.releasePointerCapture(e.pointerId);
            } catch (err) {}
          }
          return;
        }

        if (Math.abs(deltaX) > 6) {
          this.isDragging = true;
          this.track.classList.add('no-transition');
          this.trackWrapper.classList.add('is-dragging');
        }
      }

      if (this.isDragging) {
        const slideWidth = this.trackWrapper.offsetWidth || this.el.offsetWidth;
        let effectiveDelta = deltaX;

        // Resistance at boundary edges
        if ((this.current === 0 && deltaX > 0) || (this.current === this.total - 1 && deltaX < 0)) {
          effectiveDelta = deltaX * 0.35;
        }

        const baseOffset = -this.current * slideWidth;
        const currentPx = baseOffset + effectiveDelta;
        this.track.style.transform = `translate3d(${currentPx}px, 0, 0)`;
      }
    }

    onPointerUp(e) {
      if (!this.isPointerDown) return;
      this.isPointerDown = false;

      if (this.trackWrapper && typeof this.trackWrapper.releasePointerCapture === 'function') {
        try {
          this.trackWrapper.releasePointerCapture(e.pointerId);
        } catch (err) {}
      }

      this.track.classList.remove('no-transition');
      if (this.trackWrapper) {
        this.trackWrapper.classList.remove('is-dragging');
      }

      if (this.isDragging) {
        this.preventClick = true;
        setTimeout(() => {
          this.preventClick = false;
        }, 300);

        const deltaX = this.currentX - this.startX;
        const deltaTime = Date.now() - this.startTime;
        const velocity = deltaX / (deltaTime || 1);
        const slideWidth = this.trackWrapper.offsetWidth || this.el.offsetWidth;
        const threshold = Math.min(80, slideWidth * 0.15);

        if (deltaX < -threshold || velocity < -0.35) {
          this.next();
        } else if (deltaX > threshold || velocity > 0.35) {
          this.prev();
        } else {
          this.goTo(this.current);
        }

        this.isDragging = false;
      }

      if (this.autoplay && !this.isHovered) {
        this.play();
      }
    }

    goTo(index, animate = true) {
      this.current = (index + this.total) % this.total;
      this.updateTrackPosition(animate);
      this.updateSlides();
      this.updateDots();
      this.resetProgressBar();

      if (this.autoplay && !this.isHovered && !this.isDragging) {
        this.play();
      }
    }

    updateTrackPosition(animate = true) {
      if (!animate) {
        this.track.classList.add('no-transition');
      }
      this.track.style.transform = `translate3d(-${this.current * 100}%, 0, 0)`;
      if (!animate) {
        this.track.offsetHeight; // reflow
        this.track.classList.remove('no-transition');
      }
    }

    updateSlides() {
      this.slides.forEach((slide, i) => {
        const isActive = i === this.current;
        slide.classList.toggle('pnc-slide--active', isActive);

        if (isActive) {
          const content = slide.querySelector('.pnc-slide__content');
          if (content) {
            content.style.animation = 'none';
            content.offsetHeight; // reflow
            content.style.animation = '';
          }
        }
      });
    }

    updateDots() {
      this.dots.forEach((dot, i) => {
        const isActive = i === this.current;
        dot.classList.toggle('pnc-slider__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    resetProgressBar() {
      if (this.progressBar) {
        this.progressBar.style.animation = 'none';
        this.progressBar.offsetHeight; // reflow
        this.progressBar.style.animationDuration = `${this.speed / 1000}s`;
        this.progressBar.style.animation = '';
        if (this.isHovered || this.isDragging || !this.autoplay) {
          this.progressBar.style.animationPlayState = 'paused';
        } else {
          this.progressBar.style.animationPlayState = 'running';
        }
      }
    }

    next() {
      this.goTo(this.current + 1);
    }

    prev() {
      this.goTo(this.current - 1);
    }

    play() {
      this.pause();
      if (!this.autoplay || this.total <= 1) return;
      if (this.progressBar) {
        this.progressBar.style.animationPlayState = 'running';
      }
      this.timer = setInterval(() => {
        this.next();
      }, this.speed);
    }

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.progressBar) {
        this.progressBar.style.animationPlayState = 'paused';
      }
    }

    destroy() {
      this.pause();
    }
  }

  function initPncBannerSliders() {
    document.querySelectorAll('.pnc-banner-slider').forEach(el => {
      if (!el._pncSlider) {
        el._pncSlider = new PncBannerSlider(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPncBannerSliders);
  } else {
    initPncBannerSliders();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const slider = e.target.querySelector('.pnc-banner-slider');
    if (slider) {
      slider._pncSlider = new PncBannerSlider(slider);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const slider = e.target.querySelector('.pnc-banner-slider');
    if (slider && slider._pncSlider) {
      slider._pncSlider.destroy();
      delete slider._pncSlider;
    }
  });

  document.addEventListener('shopify:block:select', (e) => {
    const slider = e.target.closest('.pnc-banner-slider') || e.target.querySelector('.pnc-banner-slider');
    if (slider && slider._pncSlider) {
      const slide = e.target.classList.contains('pnc-slide') ? e.target : e.target.querySelector('.pnc-slide');
      if (slide) {
        const index = parseInt(slide.dataset.index, 10);
        if (!isNaN(index)) slider._pncSlider.goTo(index);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diwali"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('diwali-featured-collection')) {
    class DiwaliFeaturedCollection extends HTMLElement {
      connectedCallback() {
        this.bootFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.controller) return;

        this.track = this.querySelector('[data-track]');
        this.items = Array.from(this.querySelectorAll('[data-item]'));

        if (!this.track || !this.items.length) return;

        this.controller = new AbortController();

        const signal = this.controller.signal;

        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.arrows = this.querySelector('[data-arrows]');
        this.navigation = this.querySelector('[data-navigation]');
        this.status = this.querySelector('[data-status]');
        this.progress = this.querySelector('[data-progress]');
        this.toggle = this.querySelector('[data-autoplay-toggle]');

        this.motion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        this.autoplayEnabled =
          this.dataset.autoplay === 'true' &&
          this.dataset.editor !== 'true';

        this.userPaused = false;
        this.focused = this.contains(document.activeElement);

        this.hovered =
          window.matchMedia('(hover: hover)').matches &&
          this.matches(':hover');

        this.visible = false;
        this.interval = Math.max(
          3000,
          Number(this.dataset.interval) || 5000
        );

        this.previous.addEventListener(
          'click',
          () => this.move(-1, true),
          { signal }
        );

        this.next.addEventListener(
          'click',
          () => this.move(1, true),
          { signal }
        );

        this.toggle.addEventListener(
          'click',
          () => {
            this.userPaused = !this.userPaused;
            this.refreshPlayback();
          },
          { signal }
        );

        this.addEventListener(
          'pointerenter',
          (event) => {
            if (event.pointerType !== 'mouse') return;
            this.hovered = true;
            this.schedule();
          },
          { signal }
        );

        this.addEventListener(
          'pointerleave',
          (event) => {
            if (event.pointerType !== 'mouse') return;
            this.hovered = false;
            this.schedule();
          },
          { signal }
        );

        this.addEventListener(
          'focusin',
          (event) => {
            this.focused = true;

            if (!this.toggle.contains(event.target)) {
              this.userPaused = true;
            }

            this.refreshPlayback();
          },
          { signal }
        );

        this.addEventListener(
          'focusout',
          (event) => {
            this.focused = this.contains(event.relatedTarget);
            this.schedule();
          },
          { signal }
        );

        this.track.addEventListener(
          'pointerdown',
          () => this.pause(),
          { signal, passive: true }
        );

        this.track.addEventListener(
          'wheel',
          () => this.pause(),
          { signal, passive: true }
        );

        this.track.addEventListener(
          'keydown',
          (event) => {
            if (event.target !== this.track) return;

            const keys = [
              'ArrowLeft',
              'ArrowRight',
              'Home',
              'End'
            ];

            if (!keys.includes(event.key)) return;

            event.preventDefault();
            this.pause();

            if (event.key === 'Home') {
              this.goTo(0);
            } else if (event.key === 'End') {
              this.goTo(this.maximum);
            } else {
              const direction =
                (event.key === 'ArrowRight' ? 1 : -1) *
                (this.rtl ? -1 : 1);

              this.move(direction, true);
            }
          },
          { signal }
        );

        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(this.paintFrame);

            this.paintFrame = requestAnimationFrame(
              () => this.paint()
            );

            clearTimeout(this.settleTimer);

            this.settleTimer = setTimeout(() => {
              this.updateStatus();
              this.schedule();
            }, 160);
          },
          { signal, passive: true }
        );

        document.addEventListener(
          'visibilitychange',
          () => this.schedule(),
          { signal }
        );

        this.motion.addEventListener(
          'change',
          () => this.refreshPlayback(),
          { signal }
        );

        this.resizeObserver = new ResizeObserver(
          () => this.measure()
        );

        this.resizeObserver.observe(this.track);

        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            this.visible = entries[0].isIntersecting;
            this.schedule();
          },
          { threshold: 0 }
        );

        this.intersectionObserver.observe(this);

        this.classList.add('is-ready');
        this.measure();
      }

      get position() {
        return Math.max(
          0,
          Math.min(
            this.maximum || 0,
            Math.abs(this.track.scrollLeft)
          )
        );
      }

      measure() {
        this.rtl =
          getComputedStyle(this.track).direction === 'rtl';

        this.maximum = Math.max(
          0,
          this.track.scrollWidth - this.track.clientWidth
        );

        const first = this.items[0].getBoundingClientRect();

        this.points = this.items
          .map((item) => {
            const box = item.getBoundingClientRect();

            const offset = this.rtl
              ? first.right - box.right
              : box.left - first.left;

            return Math.min(
              this.maximum,
              Math.max(0, offset)
            );
          })
          .filter((point, index, points) => {
            return index === 0 ||
              point - points[index - 1] > 2;
          });

        if (
          this.maximum -
          this.points[this.points.length - 1] > 2
        ) {
          this.points.push(this.maximum);
        }

        this.hasOverflow = this.maximum > 2;

        this.arrows.hidden = !this.hasOverflow;
        this.navigation.hidden = !this.hasOverflow;

        this.paint();
        this.updateStatus();
        this.refreshPlayback();
      }

      paint() {
        const position = this.position;

        this.previous.setAttribute(
          'aria-disabled',
          String(position <= 2)
        );

        this.next.setAttribute(
          'aria-disabled',
          String(position >= this.maximum - 2)
        );

        const ratio = this.track.scrollWidth
          ? Math.min(
              1,
              (position + this.track.clientWidth) /
              this.track.scrollWidth
            )
          : 1;

        this.progress.style.setProperty(
          '--dw-progress',
          ratio.toFixed(4)
        );
      }

      updateStatus() {
        const bounds = this.track.getBoundingClientRect();
        const visible = [];

        this.items.forEach((item, index) => {
          const box = item.getBoundingClientRect();

          const overlap =
            Math.min(box.right, bounds.right) -
            Math.max(box.left, bounds.left);

          if (overlap >= box.width * .5) {
            visible.push(index + 1);
          }
        });

        const first = visible[0] || 1;
        const last = visible[visible.length - 1] || first;

        const text = this.dataset.statusTemplate
          .replace('[first]', first)
          .replace('[last]', last);

        if (this.status.textContent !== text) {
          this.status.textContent = text;
        }
      }

      goTo(position) {
        this.track.scrollTo({
          left: this.rtl ? -position : position,
          behavior: this.motion.matches ? 'instant' : 'smooth'
        });
      }

      move(direction, manual = false) {
        if (manual) this.pause();
        if (!this.hasOverflow) return;

        const position = this.position;

        const target = direction > 0
          ? this.points.find(
              (point) => point > position + 2
            )
          : [...this.points].reverse().find(
              (point) => point < position - 2
            );

        if (target !== undefined) {
          this.goTo(target);
        } else if (!manual && direction > 0) {
          this.goTo(0);
        }
      }

      pause() {
        this.userPaused = true;
        this.refreshPlayback();
      }

      refreshPlayback() {
        const allowed =
          this.autoplayEnabled &&
          !this.motion.matches &&
          this.hasOverflow;

        const playing = allowed && !this.userPaused;

        this.toggle.hidden = !allowed;
        this.toggle.dataset.playing = String(playing);

        this.toggle.setAttribute(
          'aria-label',
          playing
            ? this.dataset.pauseLabel
            : this.dataset.playLabel
        );

        this.status.setAttribute(
          'aria-live',
          playing ? 'off' : 'polite'
        );

        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);

        const protectedFocus =
          this.focused &&
          !this.toggle.contains(document.activeElement);

        if (
          !this.isConnected ||
          !this.autoplayEnabled ||
          this.motion.matches ||
          this.userPaused ||
          this.hovered ||
          protectedFocus ||
          !this.visible ||
          document.hidden ||
          !this.hasOverflow
        ) {
          return;
        }

        this.timer = setTimeout(() => {
          this.move(1);
          this.schedule();
        }, this.interval);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.bootFrame);
        cancelAnimationFrame(this.paintFrame);

        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);

        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();

        this.controller = null;
        this.classList.remove('is-ready');
      }
    }

    customElements.define(
      'diwali-featured-collection',
      DiwaliFeaturedCollection
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
